import { RootState } from "../rootReducer"

export const selectForgotPasswordState = (state: RootState) => state.password.forgotPassword
export const selectForgotPasswordEmailAddress = (state: RootState) => state.password.forgotPassword.data
export const selectVerifyResetPasswordCodeState = (state: RootState) => state.password.verifyResetPasswordCode
export const selectResetPasswordState = (state: RootState) => state.password.resetPassword
export const selectResetPasswordSuccess = (state: RootState) => state.password.resetPassword.data || false
